import merge from 'lodash.merge';

// Helper for converting YOS style ratio 2:3 to YCOS (Picture) padding
export const ratioToPadding = (ratio = '') => {
    const [width, height] = ratio.split(':', 2);
    const parsedDivision = parseFloat(height) / parseFloat(width);

    if (Number.isNaN(parsedDivision)) {
        return undefined;
    }

    return parsedDivision.toFixed(4);
};

export const getTheme = (baseTheme, customTheme) => {
    return merge(baseTheme, { custom: customTheme });
};
